import type { RootObject } from '../types/orgType';
import { useQuery } from '@tanstack/react-query';
import { request } from '../services/request';

export const useOrgType = (enabled = true) => {
    return useQuery<RootObject, Error>(
        ['OrgType'],
        async () => {
            const jsonResponse = await request({
                endpoint: 'org/get-OrgType',
            });

            if (!jsonResponse.success) {
                throw new Error(jsonResponse.data.Message || 'Something went wrong');
            }

            return jsonResponse;
        },
        {
            enabled,
    refetchOnWindowFocus: false,  

        }
    );
};
